var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDoubleArrow(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "double_arrow"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3583_57859",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3583_57859)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "double_arrow_2",
    d: "M6.26653 8L3.16032 4.125C2.97328 3.8869 2.9499 3.63988 3.09018 3.38393C3.23046 3.12798 3.4676 3 3.8016 3C3.9352 3 4.06212 3.02679 4.18236 3.08036C4.30261 3.13393 4.39613 3.20833 4.46293 3.30357L8.23046 8L4.46293 12.6964C4.39613 12.7917 4.30261 12.8661 4.18236 12.9196C4.06212 12.9732 3.9352 13 3.8016 13C3.48096 13 3.24716 12.872 3.1002 12.6161C2.95324 12.3601 2.97328 12.1131 3.16032 11.875L6.26653 8ZM11.0361 8L7.92986 4.125C7.74282 3.8869 7.71944 3.63988 7.85972 3.38393C8 3.12798 8.23714 3 8.57114 3C8.70474 3 8.83166 3.02679 8.9519 3.08036C9.07214 3.13393 9.16566 3.20833 9.23246 3.30357L13 8L9.23246 12.6964C9.16566 12.7917 9.07214 12.8661 8.9519 12.9196C8.83166 12.9732 8.70474 13 8.57114 13C8.2505 13 8.0167 12.872 7.86974 12.6161C7.72278 12.3601 7.74282 12.1131 7.92986 11.875L11.0361 8Z",
    fill: "#357EFF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleArrow);
export default __webpack_public_path__ + "static/media/double_arrow.058ea9440723dabd705418b5c71fcf62.svg";
export { ForwardRef as ReactComponent };